<template>
  <div class="index-product-component app-flex-column-center">
    <div class="content app-flex-row">
      <div class="left">
        <div class="cover"></div>
        <div
          v-for="(item, index) in switchData"
          v-show="index == activeIndex"
          :key="item.id"
          class="media-container"
        >
          <img
            v-if="item.mediaType == 'image'"
            v-lazy="item.data"
            class="media"
            :title="`微博营销 ${item.type}`"
            :alt="`微博营销 ${item.type}`"
          />
          <video
            v-else
            :src="item.data"
            class="media"
            autoplay
            muted
            loop
          ></video>
        </div>
      </div>
      <div class="right app-flex-rest app-flex-column-space-between">
        <div class="active-content">
          <h4 class="title font-26">{{ activeSwitch.title }}</h4>
          <p class="font-18">{{ activeSwitch.desc }}</p>
        </div>
        <ul class="switch app-flex-row-space-between">
          <li
            v-for="(item, index) in switchData"
            :key="item.id"
            href="https://tui.weibo.com/"
            class="switch-item app-flex-column"
            :class="{ active: activeIndex === index }"
            @click="() => changeSwitch(index)"
          >
            <div class="switch-img app-flex-row-center">
              <img
                v-lazy="item.img"
                :title="`微博营销 ${item.type}`"
                :alt="`微博营销 ${item.type}`"
              />
            </div>
            <h5>{{ item.type }}</h5>
          </li>
        </ul>
      </div>
    </div>
    <div class="bottom app-flex-row-center">
      <span class="font-color-notice">您的广告能够以更丰富的样式呈现，</span>
      <a
        v-stat:click="{ key: 'index_product_more_click' }"
        href="https://tui.weibo.com/"
        class="font-color-primary"
        target="_blank"
      >
        查看更多广告样式
      </a>
    </div>
  </div>
</template>

<script>
import img1 from '@/assets/img/index-product-icon-1.png'
import img2 from '@/assets/img/index-product-icon-2.png'
import img3 from '@/assets/img/index-product-icon-3.png'
import productVideo from '@/assets/img/index-product/exposure.mp4'
import productImg1 from '@/assets/img/index-product/search.png'
import productImg2 from '@/assets/img/index-product/feed.png'

export default {
  inheritAttrs: false,
  data() {
    return {
      activeIndex: 0,
      switchData: [
        {
          id: '1',
          title: '开机报头',
          desc: '第一时间向微博2.30亿日活用户展现，单轮2000万PV强曝光，全天9轮通投+2轮区域，支持4种素材类型，支持3种互动形式，可对不同区域定向精准投放。',
          img: img1,
          type: '曝光类广告',
          mediaType: 'video',
          data: productVideo
        },
        {
          id: '2',
          title: '热门搜索榜',
          desc: '热搜榜焦点位置，火爆热度，超强曝光，有效吸引用户关注度。',
          img: img2,
          type: '搜索类广告',
          mediaType: 'image',
          data: productImg1
        },
        {
          id: '3',
          title: '超级粉丝通',
          desc: '灵活样式完整展现，专属落地提升效率，社交传播精准把握。',
          img: img3,
          type: '信息流广告',
          mediaType: 'image',
          data: productImg2
        }
      ]
    }
  },
  computed: {
    activeSwitch() {
      return this.switchData[this.activeIndex]
    }
  },
  methods: {
    changeSwitch(index) {
      this.activeIndex = index
    }
  }
}
</script>

<style lang="scss" scoped>
.index-product-component {
  .content {
    align-items: flex-start;
    .left {
      width: 436px;
      height: 613px;
      margin-right: 46px;
      position: relative;
      .cover {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 9;
        background: url('~@/assets/img/index-product-phone.png') no-repeat left
          top/contain;
      }
      .media-container {
        width: 290px;
        height: 513.5px;
        position: absolute;
        top: 99.5px;
        left: 75.5px;
        overflow: hidden;
        .media {
          width: 100%;
          display: block;
          object-fit: cover;
        }
      }
    }
    .right {
      padding-top: 151px;
      height: 594px;
      box-sizing: border-box;
      .active-content {
        .title {
          font-weight: bold;
          margin-bottom: 40px;
        }
      }

      .switch {
        padding-bottom: 28px;
        .switch-item {
          width: 202px;
          height: 142px;
          border-radius: 12px;
          box-sizing: border-box;
          border: 1px solid $white;
          box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.1);
          align-items: center;
          color: $text-color-desc;
          position: relative;
          cursor: pointer;
          .switch-img {
            width: 72px;
            height: 72px;
            border-radius: 50%;
            background-color: $white;
            margin: 18px 0 8px;
            img {
              width: 28px;
            }
          }

          &:hover {
            border: 1px solid $text-color-primary;
          }
          &.active {
            background-color: $text-color-primary;
            border-color: $text-color-primary;
            box-shadow: none;
            &:after {
              content: '';
              @include triangle(bottom, $text-color-primary, 14px);
              top: 0;
              left: 50%;
              position: absolute;
              transform: translate(-50%, -100%);
            }
            color: $white;
          }
        }
      }
    }
  }
  .bottom {
    width: 623px;
    height: 72px;
    margin: 62px auto 0;
    border-radius: 8px;
    background-color: $neutral-color-1;
  }
}
</style>
